<!-- <div *ngIf="showTable"> -->
<div #popuptarget></div>
<mat-paginator *ngIf="detailedTableMode" #paginator [pageSize]="12"></mat-paginator>
<mat-table #table [dataSource]="dataSource">
    <ng-container matColumnDef="indicator">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <span> </span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <div class="alert-metric-table-icon">
                <mat-icon>{{element.icon}}</mat-icon>
            </div>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="minutesLate">
        <mat-header-cell *matHeaderCellDef> Overdue </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.minutesLate | timeduration}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef> Alert Type </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.typeDisplay}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef> Description </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.description}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="currencyAmount">
        <mat-header-cell *matHeaderCellDef> Amount </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.transaction.currency}} {{element.scaledAmount}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef> Amount </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.transaction.amount | number : '1.2-2'}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="currency">
        <mat-header-cell *matHeaderCellDef> Currency </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.transaction.currency}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="desk">
        <mat-header-cell *matHeaderCellDef> Desk </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.transaction.desk}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="account">
        <mat-header-cell *matHeaderCellDef> Account </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.transaction.account}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="client">
        <mat-header-cell *matHeaderCellDef> Client </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.transaction.client}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="productType">
        <mat-header-cell *matHeaderCellDef> Product Type </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.transaction.productType}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="externalId">
        <mat-header-cell *matHeaderCellDef> External Id </mat-header-cell>
        <mat-cell *matCellDef="let element"><a (click)="showTransaction($event, element.transaction, transactionOverlay)">{{element.transaction.externalId}}</a></mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns" [ngStyle]="{'border-left': 'solid 10px transparent'}"></mat-header-row>
    <!-- <mat-row *matRowDef="let element; let row; columns: displayedColumns;" [ngStyle]="(element.type === 'Missing Payment') ? {'border-left': 'solid 10px red'} : {'border-left': 'solid 10px orange'}"></mat-row> -->
    <mat-row *matRowDef="let element; let row; columns: displayedColumns;" [ngClass]="alertClass(element)"></mat-row>
</mat-table>
<p-overlayPanel #transactionOverlay [showCloseIcon]="true" [appendTo]="popuptarget">
    <textarea class="transaction-json">{{fullTransaction}}</textarea>
</p-overlayPanel>
<!-- <p-dataTable *ngIf="detailedTableMode && tableData" [value]="tableData" scrollable="true" [rows]="12" [paginator]="false">
            <p-column header=" " ><ng-template let-row="rowData" pTemplate="body"><span [ngClass]="alertClass(row)"> </span></ng-template></p-column>
            <p-column header="Alert Type"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.type}}</span></ng-template> </p-column>
            <p-column header="Overdue"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.transaction.minutesLate | timeduration}}</span></ng-template> </p-column>
            <p-column header="Currency"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.transaction.currency}}</span></ng-template> </p-column>
            <p-column header="Amount"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.transaction.amount}}</span></ng-template> </p-column>
            <p-column header="Account"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.transaction.account}}</span></ng-template> </p-column>
            <p-column header="Client"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.transaction.client}}</span></ng-template> </p-column>
            <p-column header="Desk"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.transaction.desk}}</span></ng-template> </p-column>
            <p-column header="External Id"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.transaction.externalId}}</span></ng-template> </p-column>
            <p-column header="Product Type"> <ng-template let-row="rowData" pTemplate="body"><span>{{row.transaction.productType}}</span></ng-template> </p-column>

    </p-dataTable> -->
<!-- </div> -->